export function containsWhitespace(str: string) {
  return /\s/.test(str)
}

/**
 * A async sleep function that don't block threads based on setTimeout
 */
export function sleep(ms?: number) {
  return new Promise((resolve) => setTimeout(resolve, ms ?? 2000))
}
